module.exports = __webpack_public_path__ + "media/images/noimage-ea01a202658526c1de0b3fe62efee668.png";